module.exports = __webpack_public_path__ + "img/影像技术@2x.e16dd37a.png";